import React, { useState, useEffect } from "react";
import axios from "axios";

function AddNotificationClasswise() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [deleteDate, setDeleteDate] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [attachFile, setAttachFile] = useState(null);
  const [sendTo, setSendTo] = useState("classwise"); // 'classwise' or 'all'
const [submitting, setSubmitting] = useState(false);
const [allSections, setAllSections] = useState([]);
 const [previewImage, setPreviewImage] = useState(null);

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [filteredClass, setFilteredClass] = useState("");
const [editingId, setEditingId] = useState(null);
const [filterClassId, setFilterClassId] = useState("");
const [filterSectionId, setFilterSectionId] = useState("");

  // Get current session from localStorage
  const currentSessionId = localStorage.getItem("currentSessionId");

  useEffect(() => {
    fetchClasses();
    fetchNotifications();
  }, [currentSessionId]);

  useEffect(() => {
    loadSections();
  }, [selectedClass]);

  const fetchClasses = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`, {
        params: { sessionId: currentSessionId },
      });
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const loadSections = async () => {
    if (!selectedClass || sendTo === "all") return setSections([]);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName`, // Pass className here
        { params: { sessionId: currentSessionId } }
      );
      setSections(res.data);
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  const fetchNotifications = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/getNotifications`, {
        params: { sessionId: currentSessionId },
      });
      setNotifications(res.data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!currentSessionId) return alert("Session ID not found");

  if (sendTo === "classwise" && (!selectedClass || !sectionName)) {
    return alert("Please select both class and section");
  }

  const form = new FormData();
  form.append("title", title);
  form.append("content", content);
  form.append("deleteDate", deleteDate);
  form.append("sessionId", currentSessionId);
  form.append("sendTo", sendTo);

  if (sendTo === "classwise") {
    form.append("className", selectedClass);
    form.append("sectionName", sectionName);
  }

  if (attachFile) form.append("attachFile", attachFile);

  try {
    setSubmitting(true); // 🔥 start loading

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/createClasswiseNotification`,
      form
    );

    alert("Notification Added Successfully!");

    // Reset form
    setTitle("");
    setContent("");
    setDeleteDate("");
    setSelectedClass("");
    setSectionName("");
    setAttachFile(null);
    setSendTo("classwise");

    fetchNotifications();
  } catch (error) {
    console.error("Error creating notification:", error.response || error.message);
    alert(error.response?.data?.message || "Error creating notification");
  } finally {
    setSubmitting(false); // 🔥 stop loading
  }
};




  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/deleteClasswiseNotification/${id}`
      );
      setNotifications(notifications.filter((n) => n._id !== id));
      alert("Notification Deleted Successfully!");
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  // Filter notifications by session & optional class filter
  const filteredNotifications = notifications.filter(
    (n) =>
      n.sessionId === currentSessionId &&
      (filteredClass ? n.className === filteredClass || n.sendTo === "all" : true)
  );
// ✅ Find class by classId
const getClassById = (classId) => {
  return classes.find((c) => c._id === classId);
};

// ✅ Find section INSIDE class
const getSectionNameById = (classId, sectionId) => {
  const foundClass = classes.find((c) => c._id === classId);
  if (!foundClass || !foundClass.sections) return "-";

  const foundSection = foundClass.sections.find(
    (s) => s._id === sectionId
  );

  return foundSection ? foundSection.sectionName : "-";
};
const tableFilteredNotifications = notifications.filter((n) => {
  if (filterClassId && n.classId !== filterClassId) return false;
  if (filterSectionId && n.sectionId !== filterSectionId) return false;
  return true;
});


  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* FORM */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Send To */}
          <div className="flex flex-col md:col-span-2">
            <label className="text-gray-700 font-semibold mb-1">Send To:</label>
            <select
              value={sendTo}
              onChange={(e) => setSendTo(e.target.value)}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="classwise">Specific Class</option>
              <option value="all">All Classes in Session</option>
            </select>
          </div>

          {/* Class */}
          {sendTo === "classwise" && (
            <div className="flex flex-col">
              <label className="text-gray-700 font-semibold mb-1">Class:</label>
              <select
                value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
                className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select class</option>
                {classes.map((c) => (
                  <option key={c._id} value={c.className}>
                    {c.className}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Section */}
          {sendTo === "classwise" && (
            <div className="flex flex-col">
              <label className="text-gray-700 font-semibold mb-1">Section:</label>
              <select
                value={sectionName}
                onChange={(e) => setSectionName(e.target.value)}
                className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select section</option>
                {sections.map((s) => (
                  <option key={s._id} value={s.sectionName}>
                    {s.sectionName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Title */}
          <div className="flex flex-col md:col-span-2">
            <label className="text-gray-700 font-semibold mb-1">Notification Title</label>
            <input
              type="text"
              value={title}
              placeholder="Enter title"
              onChange={(e) => setTitle(e.target.value)}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Content */}
          <div className="flex flex-col md:col-span-2">
            <label className="text-gray-700 font-semibold mb-1">Notification Content</label>
            <textarea
              value={content}
              placeholder="Write content"
              onChange={(e) => setContent(e.target.value)}
              className="border rounded-lg px-3 py-2 h-28 outline-none focus:ring-2 focus:ring-blue-500 resize-none"
              required
            />
          </div>

          {/* Delete Date */}
          <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">Delete Date</label>
            <input
              type="date"
              value={deleteDate}
              onChange={(e) => setDeleteDate(e.target.value)}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* File Upload */}
          <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">Attach File (Optional)</label>
            <input
              type="file"
              onChange={(e) => setAttachFile(e.target.files[0])}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-start gap-10">
          <button
  type="submit"
  disabled={submitting}
  className={`px-4 py-2 rounded-lg text-white transition
    ${submitting
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-blue-500 hover:bg-blue-600"}
  `}
>
  {submitting ? "Submitting..." : editingId ? "Update" : "Submit"}

</button>


          <button
            type="button"
            onClick={() => {
              setTitle("");
              setContent("");
              setDeleteDate("");
              setSelectedClass("");
              setSectionName("");
              setAttachFile(null);
              setSendTo("classwise");
            }}
            className="bg-red-600 hover:bg-red-400 text-white px-4 py-2 rounded-lg"
          >
            Reset
          </button>
        </div>
      </form>
{/* ================= Notifications Table ================= */}
<div className="mt-10">
  <h2 className="text-xl font-bold mb-4">Added Notifications</h2>
<div className="mb-4 flex gap-4">
  <select
    value={filterClassId}
    onChange={(e) => {
      setFilterClassId(e.target.value);
      setFilterSectionId("");
    }}
    className="border rounded-lg px-3 py-2"
  >
    <option value="">All Classes</option>
    {classes.map((c) => (
      <option key={c._id} value={c._id}>
        {c.className}
      </option>
    ))}
  </select>

  <select
    value={filterSectionId}
    onChange={(e) => setFilterSectionId(e.target.value)}
    className="border rounded-lg px-3 py-2"
    disabled={!filterClassId}
  >
    <option value="">All Sections</option>
    {filterClassId &&
      getClassById(filterClassId)?.sections?.map((s) => (
        <option key={s._id} value={s._id}>
          {s.sectionName}
        </option>
      ))}
  </select>
</div>

  <div className="overflow-x-auto">
    <table className="w-full border border-gray-300">
      <thead className="bg-blue-600 text-white">
        <tr>
          <th className="p-2">Title</th>
          <th className="p-2">Content</th>
          <th className="p-2">Image</th>
          <th className="p-2">Send To</th>
          <th className="p-2">Class</th>
          <th className="p-2">Section</th>
          <th className="p-2">Delete Date</th>
          <th className="p-2">Action</th>
        </tr>
      </thead>

      <tbody>
        {notifications.length === 0 ? (
          <tr>
            <td colSpan="7" className="p-4 text-center text-gray-500">
              No notifications found
            </td>
          </tr>
        ) : (
          tableFilteredNotifications.map((n) => {

            const cls = getClassById(n.classId);
console.log("IMAGE PATH:", n.attachFile);

            return (
              <tr key={n._id} className="border-t text-center">
                <td className="p-2">{n.title}</td>
                <td className="p-2">{n.content}</td>
                <td className="p-2">
  {n.attachFile ? (
    <img
      src={
        n.attachFile.startsWith("http")
          ? n.attachFile                      // ✅ ImageKit / Cloud URL
          : `${process.env.REACT_APP_API_BASE_URL}${n.attachFile}` // ✅ Local uploads
      }
      alt="notification"
      className="w-16 h-16 object-cover rounded border mx-auto cursor-pointer hover:scale-105 transition"
      onClick={() =>
        setPreviewImage(
          n.attachFile.startsWith("http")
            ? n.attachFile
            : `${process.env.REACT_APP_API_BASE_URL}${n.attachFile}`
        )
      }
    />
  ) : (
    <span className="text-gray-400">No Image</span>
  )}
</td>




                <td className="p-2 capitalize">{n.sendTo}</td>

                {/* ✅ CLASS NAME */}
                <td className="p-2">
                  {n.sendTo === "all"
                    ? "All Classes"
                    : cls?.className || "-"}
                </td>

                {/* ✅ SECTION NAME (FROM CLASS.SECTIONS) */}
                <td className="p-2">
                  {n.sendTo === "all"
                    ? "-"
                    : getSectionNameById(n.classId, n.sectionId)}
                </td>

                <td className="p-2">
                  {new Date(n.deleteDate).toLocaleDateString()}
                </td>

                <td className="p-2">
                  <button
  onClick={() => {
    // 🔎 Find class & section from stored IDs
    const cls = classes.find((c) => c._id === n.classId);
    const sec = cls?.sections?.find((s) => s._id === n.sectionId);

    setEditingId(n._id);
    setTitle(n.title);
    setContent(n.content);
    setDeleteDate(n.deleteDate.split("T")[0]);
    setSendTo(n.sendTo);

    // ✅ IMPORTANT: set VALUES that <select> expects
    setSelectedClass(cls?.className || "");
    setSectionName(sec?.sectionName || "");

    // File inputs can't be prefilled
    setAttachFile(null);
  }}
  className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded mr-2"
>
  Edit
</button>


                  <button
                    onClick={() => handleDelete(n._id)}
                    className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  </div>
</div>

    {previewImage && (
  <div
    className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50"
    onClick={() => setPreviewImage(null)}
  >
    <div
      className="bg-white p-4 rounded-lg max-w-3xl max-h-[90vh]"
      onClick={(e) => e.stopPropagation()}
    >
      <img
        src={previewImage}
        alt="Preview"
        className="max-h-[80vh] max-w-full rounded"
      />
      <div className="text-center mt-3">
        <button
          onClick={() => setPreviewImage(null)}
          className="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
  
    </div>
    
  );
}

export default AddNotificationClasswise;